var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEmptyDialWithColors = function SvgEmptyDialWithColors(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "236px",
    height: "236px",
    viewBox: "0 0 236 236",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    width: 236,
    height: 236,
    id: "artboard_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#artboard_1",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EmptyDialWithColors",
    clipPath: "url(#clip_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.5116 12L94.4561 12C58.1299 12 26.5658 32.3888 10.5831 62.347L-0.000238742 56.6857C18.0049 22.9547 53.5498 -1.7249e-06 94.4561 0L94.4815 2.96393e-06L94.5116 12Z",
    transform: "translate(23.543945 11)",
    id: "Triangle-Intersect",
    fill: "#FFDB5A",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7593 109.296L26.8411 102.785C17.4447 88.0494 12 70.5491 12 51.7771C12 35.0954 16.2996 19.4179 23.8512 5.79249L13.3392 5.15937e-07C4.83937 15.3428 0 32.9948 0 51.7771C0 72.9493 6.14928 92.6852 16.7593 109.296Z",
    transform: "translate(11 66.222916)",
    id: "Triangle-Copy-3-Intersect",
    fill: "#1CFF00",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.000158199 12.0002C0.0640072 12 0.128188 12 0.192383 12C36.3663 12 67.818 32.2183 83.8636 61.9709L94.447 56.3096C76.379 22.7842 40.9464 1.84435e-06 0.192383 0C0.138209 0 0.0840441 4.02555e-05 0.0298889 0.000120745L-0.000158199 12.0002Z",
    transform: "translate(117.80762 11)",
    id: "Triangle-Copy-Intersect",
    fill: "#FF8E00",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7583 -1.67799e-06C22.387 15.4294 27.3052 33.2154 27.3052 52.1501C27.3052 73.6293 20.9763 93.6303 10.0816 110.39L-4.32121e-05 103.879C9.68093 88.9945 15.3052 71.229 15.3052 52.15C15.3052 35.316 10.9266 19.5046 3.24627 5.79257L13.7583 -1.67799e-06L13.7583 -1.67799e-06Z",
    transform: "translate(197.69482 65.849945)",
    id: "Triangle-Copy-2-Intersect",
    fill: "#FF0000",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "EmptyDial"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 115C0 51.4873 51.4873 0 115 0C178.513 0 230 51.4873 230 115C230 178.513 178.513 230 115 230C51.4873 230 0 178.513 0 115Z",
    transform: "translate(3 3)",
    id: "Ellipse",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#E6E6E6",
    strokeWidth: 6
  })))));
};

export { SvgEmptyDialWithColors as ReactComponent };
export default __webpack_public_path__ + "static/media/EmptyDialWithColors.188e2ab9.svg";